import Swiper from 'swiper'
import { v4 as uuid } from 'uuid'
import initActionButtons from '../action_buttons/action_buttons'
import { Carousel } from '../carousel'
import CarouselWidget, { ICarouselWidget } from '../carousel/carousel_builder'
import ga4RevealWidgetClickHandler from '../ga4_support/blocks/reveal_widget'
import { getClassList } from '../shared/utils'
import { IMeme } from './types'

/**
 * Note: GA4 impression handling not implemented.
 */
class MemeCarouselWidget extends CarouselWidget<IMeme> implements ICarouselWidget<IMeme> {
  static identifier = 'memes'

  constructor(initialList: IMeme[], block: HTMLElement) {
    super({ initialList, identifier: 'memes', title: 'Memes' })
    // noinspection JSIgnoredPromiseFromCall
    this.initBlock(block)
  }

  getCarouselItemTemplate(item: IMeme) {
    const titleClassList = [
      'carousel__title',
      { 'carousel__title--small': item.punchline.length > 70 }
    ]
    const titleClass = getClassList(titleClassList)

    return `
      <div class='carousel__item swiper-slide carousel__item--large swiper-slide' data-opacity='0.2' data-title-text='${item.punchline}'>
        <div class='carousel__img-container'>
          <img class='carousel__img' src='${item.url}' alt='carousel image' loading="lazy">
        </div>
         <div class="${titleClass}">
          <p class='carousel__text'>${item.punchline}</p>
        </div>
      </div>
    `
  }

  initContent() {
    const carouselLayout: string = this.getCarouselTemplate(this.listGet(this.itemList, 3))
    const articleId = `${this.identifier}_widget_block-${uuid()}`

    this.section.setAttribute('id', articleId)
    this.container.innerHTML = carouselLayout

    const carousel = new Carousel({
      slideChange: swiper => this.onSlideChange(swiper),
      block: this.container
    })
    carousel.init()
    initActionButtons(`#${articleId}`)
    this.setSectionData(carousel.swiper, this.section)
  }

  setSectionData(data: Swiper, widgetContainer: HTMLElement) {
    const activeElement = data.slides[data.activeIndex]
    const imgSrc = activeElement.querySelector('.carousel__img').getAttribute('src')
    const title = activeElement.querySelector('.carousel__text').textContent

    widgetContainer.setAttribute('data-carousel-img-src', imgSrc)
    widgetContainer.setAttribute('data-carousel-title', title)
    widgetContainer.setAttribute(`data-mp-share-${this.identifier}-text`, title)

    // Don't post an event until the second click.
    if (this.displayCount++ !== 0) {
      ga4RevealWidgetClickHandler(
        widgetContainer,
        'editorial',
        this.displayCount === 0 ? 'show' : 'refresh',
        imgSrc,
        title,
        this.displayCount
      )
    }
  }
}

export default MemeCarouselWidget
